const Chart1 = () => {
    return (
        <>
            <div className="card custom-card p-2 weather-card">
                <div className="card-header">
                    <div className="w-100">
                        <h4 className="mb-1">토양양분/수분</h4>
                    </div>
                </div>

                <div className="card-body weather-info">
                    <h6>질소</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            질소 시비량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            3kg/ha
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            가용 질소
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            3kg/ha
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            질소 고정
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            3kg/ha
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            질소 증발산량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            질소 용탈량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>

                    <h6 className="mt-2">인산</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            가용 인산
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            5kg/ha
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            인산 시비량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            3kg/ha
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            인산 용탈량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>

                    <h6 className="mt-2">수분</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            토양 수분
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            가용 수분
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            관수량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            강우량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            증발산량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            용탈량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            유실량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">5mm</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
